import React, { lazy, Suspense } from 'react';
import './index.css';
import { BrowserRouter as Router, Routes, Route, useParams } from "react-router-dom";
import { Toaster } from 'react-hot-toast';
import Home from "./pages/Home";
import AuthProvider from "./account/AuthContext";
import ChunkErrorBoundary from "./ChunkErrorBoundary";

// Code splitting : les pages secondaires sont chargées à la demande
// (uniquement quand la route est visitée) → bundle initial allégé.
const FlightDetails = lazy(() => import('./pages/FlightDetails'));
const APropos = lazy(() => import('./pages/APropos'));
const ReservationSheet = lazy(() => import('./pages/ReservationSheet'));
const AdminReservationsApp = lazy(() => import('./admin/AdminReservationsApp'));
const DetailReservationViaEmail = lazy(() => import('./pages/DetailReservationViaEmail'));

// Espace client
const CustomerAuth = lazy(() => import('./account/CustomerAuth'));
const EmailVerification = lazy(() => import('./account/EmailVerification'));
const ResetPassword = lazy(() => import('./account/ResetPassword'));
const RequireAuth = lazy(() => import('./account/RequireAuth'));
const CustomerDashboard = lazy(() => import('./account/CustomerDashboard'));
const CustomerReservation = lazy(() => import('./account/CustomerReservation'));
const SavedPassengers = lazy(() => import('./account/SavedPassengers'));
const CustomerSettings = lazy(() => import('./account/CustomerSettings'));

// Fallback affiché pendant le chargement d'un chunk lazy
const PageLoader = () => (
  <div
    style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f8fafc',
    }}
  >
    <div
      style={{
        padding: '16px 28px',
        borderRadius: '12px',
        background: '#fff',
        boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
        color: '#334155',
        fontWeight: 600,
      }}
    >
      Chargement…
    </div>
  </div>
);


function ReservationRoute() {
  const { reference } = useParams();
  return <DetailReservationViaEmail reference={reference} />;
}


function App() {
  return (
    <Router>
      <ChunkErrorBoundary>
        <AuthProvider>
          <Toaster position="top-right" toastOptions={{ duration: 4000 }} />
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/apropos" element={<APropos />} />
              <Route path="/details_offres" element={<FlightDetails />} />
              <Route path="/reservation" element={<ReservationSheet />} />
              <Route path="/manager" element={<AdminReservationsApp />} />
              <Route path="/reservation/:reference" element={<ReservationRoute />} />

              {/* Espace client */}
              <Route path="/compte/connexion" element={<CustomerAuth />} />
              <Route path="/compte/verification" element={<EmailVerification />} />
              <Route path="/compte/reinitialisation" element={<ResetPassword />} />
              <Route
                path="/compte"
                element={<RequireAuth><CustomerDashboard /></RequireAuth>}
              />
              <Route
                path="/compte/reservations/:reference"
                element={<RequireAuth><CustomerReservation /></RequireAuth>}
              />
              <Route
                path="/compte/passagers"
                element={<RequireAuth><SavedPassengers /></RequireAuth>}
              />
              <Route
                path="/compte/parametres"
                element={<RequireAuth><CustomerSettings /></RequireAuth>}
              />
            </Routes>
          </Suspense>
        </AuthProvider>
      </ChunkErrorBoundary>
    </Router>
  );
}

export default App;

